export const LocationTypeCodes = [
    { text: $localize`:@@location_type_Undefined:Undefined Location Type`, value: 0 },
    { text: $localize`:@@location_type_rdc:Re-Distribution Center(RDC)`, value: 201 },
    { text: $localize`:@@location_type_dc:Distribution Center(DC)`, value: 200},
    { text: $localize`:@@location_type_post_dc_delivery:Post-DC Delivery`, value: 300 },
]
